import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
export var isOnlineOnlyRestricted = function(brand) {
    return (brand === null || brand === void 0 ? void 0 : brand.forbids_online_only_retailers) && RetailerStore.get().isOnlineOnlyRetailer;
};
